<template>
    <div class="detal">
        <div class="detal_right">
            <div class="detal_title">
                <div class="pusth">
                    <div class="title">合同详情</div>
                    <!-- <div class="save" @click="handlCheckSave" v-show="$route.params.isLook == 0">生成合同</div> -->
                </div>
                <!-- <div class="prpu">
                   <div class="btn" @click="handlUpload" v-show="$route.params.isLook == 0">本地上传</div>
                   <input type="file" id="fileExport" @change="handleFileChange" ref="inputer" style="display: none;">
                   <div class="btn" v-show="$route.params.isLook == 0" @click="handlLoad">载入模板</div>
                   <div class="btn" @click="handlQian" v-show="$route.params.isSign == '需要我签名'">签署</div>
                   <div class="btn" v-show="$route.params.isLook == 0" @click="handlCheckDown">下载合同</div>
                 </div> -->
            </div>
            <div class="pacton">
                <Editor :value="Editortex" ref="editor" v-if="loadAll === 1">
                </Editor>
            </div>
            <div class="detal_title" style="margin-top: 30px;">
                <div class="pusth">
                    <div class="save" @click="handlCheckSave" v-show="$route.params.isLook == 0">生成合同</div>
                </div>
                <div class="prpu">
                    <div class="btn" @click="handlUpload" v-show="$route.params.isLook == 0">本地上传</div>
                    <input type="file" id="fileExport" @change="handleFileChange" ref="inputer" style="display: none;">
                    <div class="btn" v-show="$route.params.isLook == 0" @click="handlLoad">载入模板</div>
                    <div class="btn" @click="handlQian" v-show="$route.params.isSign == '需要我签名'">签署</div>
                    <div class="btn" v-show="$route.params.isLook == 0" @click="handlCheckDown">下载合同</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Editor from '../../editor/editor'

    import htmlDocx from 'html-docx-js/dist/html-docx';
    import saveAs from 'file-saver';

    export default {
        components: {
            Editor
        },
        data() {
            return {
                Editortex: '',
                loadAll: 0,
            }
        },
        created() {
            let _this = this;
            
            console.log("进入该页面传参", _this.$route.params );

            let param = new FormData();
            if (_this.$route.params.isMy == 0) {
                param.append('templateId', _this.$route.params.id);
                _this.getData(param);
            } else if (_this.$route.params.isMy == 1) {
                param.append('contactId', _this.$route.params.id);
                param.append('token', _this.$global.token);
                _this.getMyData(param);
            } else {
                _this.$router.push('contractSin');
            }

        },
        methods: {
            getData(param) {
                let _this = this;
                _this.api.getTemplateDetails(param).then(res => {
                    console.log(res, 'getData');
                    _this.Editortex = res.data;
                    _this.loadAll++;
                })
            },
            getMyData(param) {
                let _this = this;
                _this.api.getContactDetails(param).then(res => {
                    console.log(res, 'getMyData');
                    _this.Editortex = res.data.content;
                    _this.loadAll++;
                })
            },
            handlQian() {
                this.$router.push({
                    name: 'signContract',
                    params: {
                        pdf: this.$route.params.pdf,
                        id: this.$route.params.id
                    }
                })
            },
            handlLoad() {
                this.$router.push('Contemplate');
            },
            handlUpload() {
                this.$refs.inputer.click();
            },
            handleFileChange(e) {
                let inputDOM = this.$refs.inputer;
                let file = inputDOM.files[0];
                console.log(file);
                let size = Math.floor(file.size / 1024);
                let fromData = new FormData();
                fromData.append('token', this.$global.token)
                fromData.append('file', file)

                e.target.value = '';
                this.getContractTemp(fromData);
            },
            getContractTemp(params) {
                let _this = this;
                _this.api.addTemplateInfo(params).then(res => {
                    console.log("res:" + res);
                    _this.$message.success("上传成功");
                    _this.$router.push('myTemplate');

                })
            },

            handlCheckDown() {
                let _this = this;
                var html = this.$refs.editor.getValue();
                const converted = htmlDocx.asBlob(html);
                saveAs(converted, _this.$route.params.title + '.docx');
            },
            // 构造blob文件流
            // let html_ = new Blob([html], {
            //   "type": "text/html;charset=utf-8"
            // })
            // let formdata = new FormData();
            // formdata.append('file', html_, `test.doc`);
            handlCheckSave() {
                let _this = this;
                var html = this.$refs.editor.getValue();
                console.log(html);
                setTimeout(function () {
                    _this.exportWord(html);
                }, 100)

            },
            exportWord(content) {
                let _this = this;
                let param = new FormData();
                param.append('content', content);
                if (_this.$route.params.list == 1) {
                    param.append('id', _this.$route.params.id);
                } else {
                    param.append('templateId', _this.$route.params.id);
                }


                param.append('title', _this.$route.params.title);
                param.append('token', _this.$global.token);
                _this.api.addContactInfo(param).then(res => {
                    _this.$message.success("保存成功");
                    console.log(res);
                    _this.$router.push('contractSin');
                })

            },
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';
    @import '../../editor/editor.css';

    .detal {
        width: @a;
        height: auto;

        .detal_right {
            width: @a;
            height: auto;
            padding-left: 4%;

            .detal_title {
                width: @a;
                height: 40px;
                display: @flex;
                justify-content: space-between;

                .pusth {
                    width: 300px;
                    height: @a;
                    display: flex;
                    align-items: center;

                    .title {
                        width: 160px;
                        height: auto;
                        font-family: MicrosoftYaHei-Bold;
                        font-size: 24px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #333333;
                    }

                    .save:active {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal, normal;
                        color: #333333;
                    }

                    .save {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal, normal;
                        color: #ffffff;

                        width: 120px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        background-color: #f2f2f2;
                        border: solid 1px #aaaaaa;
                        letter-spacing: 1px;

                        // margin-left: 22px;
                        cursor: pointer;
                        font-size: 17px;
                    }
                }


                .prpu {
                    width: 520px;
                    height: 40px;
                    display: @flex;
                    justify-content: flex-end;
                    margin-left: 250px;

                    .btn:active {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal, normal;
                        color: #ffffff;
                    }

                    .btn {
                        width: 120px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        background-color: #f2f2f2;
                        border: solid 1px #aaaaaa;
                        letter-spacing: 1px;
                        color: #333333;
                        margin-left: 10px;
                        cursor: pointer;
                        font-size: 17px;
                    }
                }
            }

            .pacton {
                width: @a;
                height: auto;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/contract/detal_contract.vue